// extracted by mini-css-extract-plugin
module.exports = {"root":"BannerListing_root__VdZmq"};